import { Component, ElementRef, viewChild } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { Popover, PopoverModule } from 'primeng/popover';
import { ThemePickerComponent } from '../theme-picker/theme-picker.component';
import { ButtonModule } from 'primeng/button';
import { FontSizeSelectComponent } from '../font-size-select/font-size-select.component';

@Component({
  selector: 'app-preferences',
  imports: [TooltipModule, PopoverModule, ThemePickerComponent, ButtonModule, FontSizeSelectComponent],
  templateUrl: './preferences.component.html',
})
export class PreferencesComponent {
  pop = viewChild.required<Popover>('prefs');

  hide() {
    this.pop().hide();
  }
}
